import { render } from "./StaffDataServer.vue?vue&type=template&id=6c76cb17&scoped=true"
import script from "./StaffDataServer.vue?vue&type=script&lang=js"
export * from "./StaffDataServer.vue?vue&type=script&lang=js"

import "./StaffDataServer.vue?vue&type=style&index=0&id=6c76cb17&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6c76cb17"

export default script